import {
  SignedIn,
  SignedOut,
  SignInButton,
  UserButton,
} from "@clerk/clerk-react";
import { Link } from "react-router-dom";
import leblanc from "../../../images/leblanc.png";

export function Header() {
  return (
    <header className="bg-brand-bg border-b border-brand-border">
      <div className="flex h-16 items-center justify-between px-6">
        <Link
          to="https://www.leblanc-associes.com/"
          className="flex items-center gap-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text-sm text-brand-muted">Propulsé par</span>
          <img src={leblanc} alt="LeBlanc" className="h-8 w-auto" />
        </Link>
        <div className="flex items-center">
          <SignedOut>
            <SignInButton mode="modal">
              <button className="rounded-lg p-2 text-brand-muted hover:bg-brand-primary/5 hover:text-brand-text">
                Sign In
              </button>
            </SignInButton>
          </SignedOut>
          <SignedIn>
            <UserButton
              appearance={{
                elements: {
                  avatarBox: "h-8 w-8",
                },
              }}
            />
          </SignedIn>
        </div>
      </div>
    </header>
  );
}
